// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"responsive-module--wrapper--2Qg-K","wrapper_button":"responsive-module--wrapper_button--eFscF"};